<template>
  <b-modal
    :hide-footer="true"
    :hide-header-close="false"
    :no-close-on-backdrop="true"
    :no-close-on-esc="true"
    :title="$t('Vincular Bairro/Localidade a unidade')"
    centered
    size="xl"
    id="add-abrangencia"
  >
    <template v-slot:default>
      <load mode="table" v-if="loading" />
      <div v-else class="row">
        <div class="col-12">
          <div class="row">
            <div
              class="col-12 d-flex align-items-center justify-content-between mb-4"
            >
              <div>
                Pesquise o bairro ou localidade para inserir na área de
                abrangência desta unidade
              </div>
              <div>
                <div class="input-group mb-3">
                  <b-input
                    :placeholder="$t('Type to search')"
                    class="form-control search-input"
                    type="text"
                    v-model="search"
                    v-on:change="getLocalidades"
                    aria-describedby="input-search"
                  />
                  <div class="input-group-append" role="button">
                    <span class="input-group-text" id="input-search"
                      ><i class="fas fa-search search-icon"
                    /></span>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-12">
              <load mode="table" v-if="loading" />
              <div v-else>
                <b-table
                  :fields="[
                    {
                      key: 'nome',
                      label: $t('Nome'),
                    },
                    {
                      key: 'quant_logradouros',
                      label: $t('Qtd. Logradouros'),
                    },
                    {
                      key: 'data_cadastro',
                      label: $t('Criado em'),
                    },
                    {
                      key: 'actions',
                      label: '',
                      class: 'text-right',
                      thStyle: { width: '200px', minWidth: '200px' },
                    },
                  ]"
                  :items="localidadesList"
                  :responsive="true"
                  striped
                  hover
                  show-empty
                  small
                  outlined
                  stacked="md"
                  table-class="mb-3"
                >
                  <template v-slot:cell(nome)="data">
                    {{ data.value }}<br />
                    <span
                      v-if="data.item.vinculo.unidade_nome"
                      class="text-muted small"
                    >
                      Vinculado a
                      <strong
                        >{{ data.item.vinculo.unidade_nome }} em
                        {{ data.item.vinculo.data_vinculo }}
                      </strong>
                    </span>
                  </template>
                  <template v-slot:cell(quant_logradouros)="data">
                    {{ data.value }}
                  </template>
                  <template v-slot:cell(data_cadastro)="data">
                    {{ data.value }}
                  </template>
                  <template v-slot:cell()="data">
                    <div v-if="data.item.vinculo.unidade_id">
                      <span
                        v-if="$route.params.id == data.item.vinculo.unidade_id"
                      >
                        <b-button
                          class="px-2 mb-0"
                          variant="success"
                          size="xs"
                          type="button"
                          disabled
                        >
                          <i class="fas fa-link"></i> Vinculado a esta Unidade
                        </b-button>
                      </span>
                      <span v-else>
                        <b-button
                          class="px-2 mb-0"
                          variant="warning"
                          size="xs"
                          type="button"
                          disabled
                        >
                          <i class="fas fa-link"></i> Vinculado a outra Unidade
                        </b-button>
                      </span>
                    </div>
                    <span v-else>
                      <b-button
                        :title="$t('Inserir Bairro/Localidade')"
                        :class="'px-2 mb-0 btn-submit-' + data.item.id"
                        size="xs"
                        type="button"
                        variant="primary"
                        @click.prevent="vincularLocalidade(data.item.id)"
                      >
                        <i class="fas fa-plus-square" />
                        Vincular
                      </b-button>
                    </span>
                  </template>
                  <template v-slot:empty="scope">
                    <div class="text-center my-5">
                      <img
                        :alt="$t('No results')"
                        class="mb-5"
                        src="/img/icons/robot.svg"
                        style="max-height: 165px"
                      />
                      <h3 class="bold">{{ $t("No records found") }}</h3>
                    </div>
                  </template>
                  <template v-slot:emptyfiltered="scope">
                    <div class="text-center my-5">
                      <img
                        :alt="$t('No results')"
                        class="mb-5"
                        src="/img/icons/robot.svg"
                        style="max-height: 165px"
                      />
                      <h3>{{ $t("No records match the entered search") }}</h3>
                    </div>
                  </template>
                </b-table>

                <div class="row align-items-center">
                  <div class="col-lg-6 col-md-12">
                    <div class="form-group d-inline-flex mb-0">
                      <select
                        class="form-control"
                        style="width: 70px"
                        v-model="perPage"
                        v-on:change="getLocalidades"
                      >
                        <option value="5">5</option>
                        <option value="10">10</option>
                        <option value="25">25</option>
                        <option value="50">50</option>
                      </select>
                    </div>
                    <div class="d-inline-flex ml-2">
                      <b-pagination
                        :per-page="perPage"
                        :total-rows="pagination.total"
                        @change="changePage"
                        v-model="page"
                      />
                    </div>
                  </div>
                  <div class="col-lg-6 col-md-12 mt-4 mt-lg-0">
                    <div class="float-lg-right">
                      {{ $t("Showing page") }} {{ pagination.currentPage }}
                      {{ $t("of") }} {{ pagination.totalPages }}
                      {{ $t("pages in") }} {{ pagination.total }}
                      {{ $t("records") }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <router-view />
          </div>
        </div>
      </div>

      <div class="float-right mt-3">
        <button class="btn btn-danger" @click="close">
          <i class="mdi mdi-close" />
          {{ $t("Cancelar") }}
        </button>
      </div>
    </template>
  </b-modal>
</template>

<script>
export default {
  name: "AddAbragencia",
  props: ["id"],
  mounted() {
    this.getLocalidades();
  },
  data() {
    return {
      page: 1,
      search: "",
      perPage: 10,
      loading: false,
      pagination: {
        currentPage: 0,
        perPage: 0,
        total: 0,
        totalPages: 0,
      },
      localidadesList: [],
    };
  },
  methods: {
    open() {
      this.$bvModal.show("add-abrangencia");
    },
    close() {
      this.$bvModal.hide("add-abrangencia");
    },
    // Change the page
    changePage(page) {
      if (
        page > 0 &&
        page <= this.pagination.totalPages &&
        page !== this.page
      ) {
        this.page = page;
        this.getLocalidades();
      }
    },
    // Get roles list
    getLocalidades() {
      axios
        .get("api/dashboard/enderecos/localidades", {
          params: {
            page: this.page,
            search: this.search,
            perPage: this.perPage,
          },
        })
        .then((response) => {
          this.localidadesList = response.data.data;
          this.pagination = response.data.pagination;
          if (this.pagination.totalPages < this.pagination.currentPage) {
            this.page = this.pagination.totalPages;
            this.getLocalidades();
          } else {
            this.loading = false;
          }
        })
        .catch(() => {
          this.loading = false;
        });
    },
    vincularLocalidade(id) {
      let ladda = Ladda.create(document.querySelector(".btn-submit-" + id));
      ladda.start();

      let item = {
        unidade_id: this.id, //this.$route.params.id,
        localidade_id: id,
      };

      axios
        .post("api/dashboard/unidades/vincularbairro", item)
        .then((response) => {
          ladda.stop();
          this.$snack.success({
            button: false,
            text: response.data.data.message,
          });

          this.getLocalidades();
          this.$emit('reload');
        })
        .catch(() => {
          ladda.stop();
        });
    },
  },
};
</script>
